// frontend/src/components/layout/ConsentNotice.jsx
import { useState } from "react";
import { Link } from "react-router-dom";
import { CONSENT_STORAGE_KEY, ROUTES } from "../../config";
import Button from "../common/Button";
import "./ConsentNotice.css";

function alreadyDismissed() {
  try {
    return localStorage.getItem(CONSENT_STORAGE_KEY) === "dismissed";
  } catch {
    return false;
  }
}

/**
 * Essential-storage notice. PAWNI uses no tracking or advertising cookies,
 * so there is nothing to opt into: this is an informational notice only.
 * Dismissal is remembered in localStorage under `pawni_consent_v1`.
 */
export default function ConsentNotice() {
  const [visible, setVisible] = useState(() => !alreadyDismissed());
  if (!visible) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(CONSENT_STORAGE_KEY, "dismissed");
    } catch {
      /* storage unavailable: hide for this page view only */
    }
    setVisible(false);
  };

  return (
    <section className="consent" aria-label="Storage notice">
      <p className="consent__text">
        We only use essential browser storage to keep you signed in and remember your theme. No tracking,
        no ads. <Link to={ROUTES.cookies}>Read the cookie notice</Link>.
      </p>
      <Button size="sm" variant="secondary" onClick={dismiss}>
        Got it
      </Button>
    </section>
  );
}
